module.exports = __webpack_public_path__ + "img/activity_11.36122273.jpg";